import findIndex from 'lodash-es/findIndex';
import { UNKNOWN_ERROR } from '../../constants';

const state = {
    popupMessages: [],
};

const mutations = {
    OPEN_POPUP: (state, message) => {
        state.popupMessages.push(message);
    },
    CLOSE_POPUP: (state, index) => {
        state.popupMessages.splice(index, 1);
    },
    CLEAR_MESSAGES: state => {
        state.popupMessages = [];
    },
};

const actions = {
    popup(
        { state, commit, dispatch },
        { type = UNKNOWN_ERROR, header = UNKNOWN_ERROR, text = '', visible = true }
    ) {
        if (text) {
            let message = {
                type,
                header,
                text,
                visible,
            };
            // eliminate popup duplicates
            if (
                (state.popupMessages.length > 0 &&
                    (state.popupMessages[state.popupMessages.length - 1].type !== message.type ||
                        state.popupMessages[state.popupMessages.length - 1].text !== message.text)) ||
                state.popupMessages.length === 0
            ) {
                commit('OPEN_POPUP', message);
                setTimeout(() => {
                    dispatch('closePopup', message);
                }, 7000);
            }
        }
    },

    closePopup({ state, commit }, message) {
        let index = findIndex(state.popupMessages, message);
        if (state.popupMessages.length > 0) {
            commit('CLOSE_POPUP', index);
        }
    },

    clearMessages({ commit }) {
        commit('CLEAR_MESSAGES');
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
